export default __webpack_public_path__ + "static/media/arrow-down.5f546ee6.svg";